<template>
  <div class="content">
    <div>
      <h2>{{ $domain.name }}法律声明</h2>
      <h3>版权声明</h3>
      <p class="q">
        "
        {{
          $domain.name
        }}所有发布的作品（包括但不限于课程视频、音频、课件、教材、绘本、题目等）著作权及邻接权归
        {{ $domain.company }}及其关联公司所有，
        均受《中华人民共和国著作权法》及国际版权公约的保护。
      </p>
      <p>
        {{
          $domain.name
        }}App所有作品允许购买者在线观看学习、缓存下载，不可销售、传播，
        未经许可，严禁任何人私自变更、发行、复制、转载和散发
        {{ $domain.name }}App网站已经发布的信息资料。
        对于上述版权内容，超越合理使用范畴、并未经本公司书面许可的使用行为，我公司均保留追究法律责任的权利。
      </p>
      <h3>商标声明</h3>
      <p>
        {{
          $domain.company
        }}对“小白云课堂”、“小白教育”、“小白美术“、“星绘插画”、“星绘教育”、“星绘美术“等文字及图形均进行了商标保护，
        未经公司的许可而使用上述商标，可能会侵犯公司的商标权，对于涉嫌侵犯公司商标权的行为，我公司将保留追究法律责任的权利。
      </p>
      <h3>品牌声明</h3>
      <p>
        {{
          $domain.name
        }}App所有作品仅通过官方网站、官方APP向用户展示及销售，除此以外的任何销售途径均未获得官方授权。
        {{
          $domain.name
        }}不做任何形式的品牌加盟及代理，网上关于加盟及代理的信息均为诈骗，请大家谨防上当受骗。"
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.content {
  div {
    width: 1200px;
    margin: 0 auto;
  }
}
h2 {
  margin-top: 50px;
  text-align: center;
  font-size: 32px;
  color: #272c38;
}
h3 {
  margin-top: 38px;
  margin-bottom: 15px;
  font-size: 24px;
  color: #202020;
}
p {
  line-height: 30px;
  font-size: 20px;
  letter-spacing: -1px;
  color: #444444;
  margin-bottom: 90px;
}
.q {
  margin-bottom: 30px;
}
</style>
